import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@/components/display/button';
import { useCampaignContext } from '@/features/campaigns/campaign-context';

const ZOHO_CREATE_IO_URL =
  'https://crm.zoho.com/crm/org643932192/tab/CustomModule19/create?layoutId=2461504000130477043';

type IOWarningBannerProps = {
  isIOsRailOpen: boolean;
  openIOsRail: () => void;
};

export function IOWarningBanner({ isIOsRailOpen, openIOsRail }: IOWarningBannerProps) {
  const { ios, iosLoading, iosError } = useCampaignContext();

  const hasCompletedIO = ios.some(io => io.status === 'completed');
  if (iosLoading || iosError || hasCompletedIO) return null;

  if (ios.length === 0) {
    return <NoIOCreatedBanner />;
  }

  return <NoIOCompletedBanner isRailOpen={isIOsRailOpen} openRail={openIOsRail} />;
}

function NoIOCreatedBanner() {
  const handleCreateClick = () => {
    window.open(ZOHO_CREATE_IO_URL, '_blank');
  };

  return (
    <div className="flex items-center rounded bg-red-500 p-1">
      <div className="flex h-full items-center px-3">
        <FontAwesomeIcon icon={faTriangleExclamation} className="text-white" />
      </div>
      <div className="flex h-full flex-1 items-center justify-between rounded bg-red-100 px-2">
        <span className="text-sm text-gray-800 py-1.5">
          No IO has been <span className="font-bold">created</span> for this execution.
        </span>
        <Button size="compact" onClick={handleCreateClick}>
          Create Insertion Order in Zoho
        </Button>
      </div>
    </div>
  );
}

function NoIOCompletedBanner({
  isRailOpen,
  openRail
}: {
  isRailOpen: boolean;
  openRail: () => void;
}) {
  return (
    <div className="flex items-center rounded bg-red-500 p-1">
      <div className="flex h-full items-center px-3">
        <FontAwesomeIcon icon={faTriangleExclamation} className="text-white" />
      </div>
      <div className="flex h-full flex-1 items-center justify-between rounded bg-red-100 px-2">
        <span className="text-sm text-gray-800 py-1.5">
          No IO has been <span className="font-bold">Completed</span> for this execution.
        </span>
        {!isRailOpen && (
          <Button size="compact" onClick={openRail}>
            View IOs
          </Button>
        )}
      </div>
    </div>
  );
}
